export default __webpack_public_path__ + "static/img-rhizome-dao-7396945bf153fff8d04fa21c79f37410.png";